const HOME_QUEUES = 'queues' as const;
const HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight' as const;
const HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight' as const;
const HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight' as const;
const HOME_SERVICE_REQUESTS = 'service-requests' as const;
const HOME_INCIDENTS = 'incidents' as const;
const HOME_CHANGES = 'changes' as const;
const HOME_PROBLEMS = 'problems' as const;
const HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews' as const;
const HOME_CUSTOMERS = 'customers' as const;
const HOME_REPORTS = 'reports' as const;
const HOME_RAISE_REQUEST = 'raise-request' as const;
const HOME_ISSUES = 'issues' as const;
const HOME_CUSTOMER_CHANNELS = 'customer-channels' as const;
const HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight' as const;
const HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog' as const;
const HOME_KNOWLEDGE_BASE = 'knowledge-base' as const;
const HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub' as const;
const HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested' as const;
const HOME_INVITE_TEAM = 'invite-team' as const;
const HOME_GIVE_FEEDBACK = 'give-feedback' as const;
const HOME_SERVICES = 'services' as const;
const HOME_SERVICES_SPOTLIGHT = 'services-spotlight' as const;
const HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight' as const;
const HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight' as const;

export const REPORTS_IDS = {
	REPORTS_CUSTOM: 'sd-reports-custom',
	REPORTS_ADDONS: 'sd-reports-addons',
	REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
	REPORTS_NAV_TEAM: 'sd-reports-nav-team',
	REPORTS_NAV_KB: 'sd-reports-nav-kb',
} as const;

export const HOME_ITEMS_IDS = {
	QUEUES: HOME_QUEUES,
	ALL_ITSM_QUEUES_SPOTLIGHT: HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
	ALL_TICKETS_SPOTLIGHT: HOME_ALL_TICKETS_SPOTLIGHT,
	TICKET_CATEGORIES_SPOTLIGHT: HOME_TICKET_CATEGORIES_SPOTLIGHT,
	SERVICE_REQUEST: HOME_SERVICE_REQUESTS,
	INCIDENTS: HOME_INCIDENTS,
	CHANGES: HOME_CHANGES,
	PROBLEMS: HOME_PROBLEMS,
	CUSTOMERS: HOME_CUSTOMERS,
	POST_INCIDENT_REVIEWS: HOME_POST_INCIDENT_REVIEWS,
	REPORTS: HOME_REPORTS,
	RAISE_REQUEST: HOME_RAISE_REQUEST,
	ISSUES: HOME_ISSUES,
	CUSTOMER_CHANNELS: HOME_CUSTOMER_CHANNELS,
	CUSTOMER_CHANNELS_SPOTLIGHT: HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
	JSD_CHANNELS_DIALOG: HOME_JSD_CHANNELS_DIALOG,
	KNOWLEDGE_BASE: HOME_KNOWLEDGE_BASE,
	KNOWLEDGE_BASE_HUB: HOME_KNOWLEDGE_BASE_HUB,
	KNOWLEDGE_BASE_HUB_NESTED: HOME_KNOWLEDGE_BASE_HUB_NESTED,
	INVITE_TEAM: HOME_INVITE_TEAM,
	GIVE_FEEDBACK: HOME_GIVE_FEEDBACK,
	SERVICES: HOME_SERVICES,
	SERVICES_SPOTLIGHT: HOME_SERVICES_SPOTLIGHT,
	ALERTS_AND_ON_CALL_SPOTLIGHT: HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
	CHANGE_CALENDAR_SPOTLIGHT: HOME_CHANGE_CALENDAR_SPOTLIGHT,
} as const;

const KNOWLEDGE_BASE_IDS = {
	TOP_ACTIONS: 'knowledge-hub-top-actions',
	ALL_ARTICLES: 'knowledge-hub-all-articles',
	CATEGORIES: 'knowledge-hub-categories',
	CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
	BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
	ADD_CATEGORY: 'knowledge-hub-new-category',
	LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback',
} as const;

const SETTINGS_IDS = {
	DETAILS: 'details',
	PEOPLE: 'people',
	ITSM_FEATURES: 'itsm-features',
	SUMMARY: 'summary',
	DELETE_PROJECT: 'delete-project',
	ISSUE_TYPES: 'issue-types',
	FEATURES: 'features',
	REQUEST_TYPES: 'sd-request-types',
	TICKET_TYPES: 'sd-ticket-types',
	CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
	LANGUAGE_SUPPORT: 'sd-language-support',
	PORTAL_SETTINGS: 'sd-portal-settings',
	EMAIL_REQUESTS: 'sd-email-requests',
	CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
	PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
	PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
	PROJECT_ASSETS_AD: 'sd-project-assets-ad',
	SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
	KNOWLEDGE_BASE: 'sd-knowledge-base',
	SLAS: 'sd-slas',
	AUTOMATION: 'sd-automation',
	PLAYBOOKS: 'playbooks',
	JIRA_AUTOMATION: 'jira-automation',
	AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
	JSD_APP_DISCOVERY: 'sd-app-discovery',
	JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
	JSD_CHANGE_MANAGEMENT: 'sd-change-management',
	WORKFLOWS: 'workflows',
	SCREENS: 'screens',
	FIELDS: 'fields',
	VERSIONS: 'versions',
	COMPONENTS: 'components',
	PERMISSIONS: 'permissions',
	ISSUE_SECURITY: 'issue-security',
	NOTIFICATIONS: 'notifications',
	HIPCHAT: 'hipchat',
	ISSUE_COLLECTORS: 'issue-collectors',
} as const;

const QUEUES_IDS = {
	QUEUE_NEW: 'queue-new',
	QUEUE_MANAGE: 'queue-manage',
	QUEUES_ADDONS: 'sd-queues-addons',
	QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
	SD_QUEUES_CUSTOM: 'sd-queues-custom',
} as const;

export const PRACTICES_IDS = {
	ADDITIONAL_ITEMS: 'sd-practices-additional-items',
	CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
	CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
	INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
	INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight',
} as const;

export const SERVICE_DESK_ITEMS = {
	SERVICE_DESK: {
		HOME: HOME_ITEMS_IDS,
		KNOWLEDGE_BASE: KNOWLEDGE_BASE_IDS,
		SETTINGS: SETTINGS_IDS,
		QUEUES: QUEUES_IDS,
		REPORTS: REPORTS_IDS,
	},
} as const;

export const REQUEST_TYPE_PRACTICE_NAV_ONBOARDING = {
	PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
	UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight',
} as const;

export const STARRED_QUEUE_SPOTLIGHT = 'jsm-team-starred-onboarding';

export const SERVICE_DESK = 'project/service-desk/index' as const;
export const SERVICE_DESK_ISSUES = 'project/service-desk/issues' as const;
export const SERVICE_DESK_QUEUES = 'project/service-desk/queues' as const;
export const SERVICE_DESK_KNOWLEDGE_HUB = 'project/service-desk/knowledge-hub' as const;
export const SERVICE_DESK_REPORTS = 'project/service-desk/reports' as const;
export const SERVICE_DESK_SETTINGS = 'project/service-desk/settings' as const;
export const SERVICE_DESK_LEGACY_TICKET_TYPES = 'project/service-desk/legacy-ticket-types' as const;
export const SERVICE_DESK_LANGUAGES = 'project/service-desk/languages' as const;
export const SERVICE_DESK_TRANSLATIONS = 'project/service-desk/translations' as const;
export const SERVICE_DESK_AUTOMATION_SUB_NAV =
	'project/service-desk/settings/automation-sub-nav' as const;
